import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/shared/api/client"
import type { Topic } from "@/shared/lib/types"

const fetchTopics = async (): Promise<Topic[]> => {
	const { data } = await apiClient.get<Topic[]>("/topics")
	return data
}

export const useTopics = () => {
	return useQuery({
		queryKey: ["topics"],
		queryFn: fetchTopics,
	})
}
